export default "__VITE_ASSET___tMNvOWX__"